<template>
  <div class="content">
    <el-form ref="searchInfo" :model="searchInfo" :inline="true">
      <el-form-item prop="patrolMode">
        <el-select v-model="searchInfo.patrolMode" placeholder="选择巡查方式" clearable
                   @change="onSearch">
          <el-option v-for="(item, ind) in patrolModeList" :label="item.label" :value="item.value" :key="'i' + ind"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="planType" class="mr0">
        <el-select v-model="searchInfo.planType" placeholder="选择巡查类型" clearable
                   @change="onSearch">
          <el-option v-for="(item, ind) in planTypeList" :label="item.label" :value="item.value" :key="'i' + ind"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="list">
      <ul class="infinite-list" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
        <li v-for="(item, index) in list" class="global-right-section infinite-list-item" :class="{ active: index === currentIndex }" @click="onSelect(index)" :key="'item' + index">
          <div class="item-header">
            <p class="name">{{item.planName || ''}}</p>
            <div class="label">
              <span class="bg-green">
                <template v-if="item.patrolMode === 1">
                  <i class="iconfont icon-zuoce-xianlu"></i>线路
                </template>
                <template v-else>
                  <i class="iconfont icon-dianwei"></i>点位
                </template>
              </span>
              <span>{{item.planType | planTypeFilter}}巡查</span>
            </div>
          </div>
          <div class="item-ctt">
            <p>管理类型：{{item.safeManageName || ''}}</p>
            <p>巡查频次：{{item.patrolFrequency || '0'}}次/{{item.planType | planTypeFilter}}</p>
            <p>执 行 人：{{item.executeUserName || ''}}</p>
            <p>完成情况：完{{item.ywcTaskCount || '0'}} / 共{{item.taskCount || '0'}}</p>
          </div>
        </li>
      </ul>
      <p class="tip" v-if="loading">加载中...</p>
      <template v-if="noMore">
        <p class="tip" v-if="list && list.length">没有更多了</p>
        <p class="tip" v-else>
          <img src="@/assets/img/empty.svg" alt="">
        </p>
      </template>
    </div>
    <RecordList :planId="planId" :isShow.sync="isShowRecord"></RecordList>
  </div>
</template>

<script>
import RecordList from './RecordList'
export default {
  name: 'TaskList',
  components: { RecordList },
  data () {
    return {
      patrolModeList: [{
        label: '线路',
        value: '1'
      }, {
        label: '点位',
        value: '2'
      }],
      planTypeList: [{
        label: '日巡查',
        value: '1'
      }, {
        label: '周巡查',
        value: '2'
      }, {
        label: '月巡查',
        value: '3'
      }],
      searchInfo: {
        patrolMode: '',
        planType: ''
      },
      list: [],
      currentIndex: -1,
      isShowRecord: false,
      noMore: false,
      loading: false,
      page: 1,
      size: 10
    }
  },
  filters: {
    planTypeFilter (val) {
      return val === 2 ? '周' : val === 3 ? '月' : '日'
    }
  },
  watch: {
    projectId () {
      this.onSearch()
    }
  },
  computed: {
    projectId () {
      return this.$store.state.projectId || ''
    },
    planId () {
      return this.currentIndex >= 0 && this.list[this.currentIndex] ? this.list[this.currentIndex].planId : ''
    },
    disabled () {
      return this.loading || this.noMore
    }
  },
  created () {
  },
  methods: {
    onSearch () {
      this.currentIndex = -1
      this.page = 1
      this.list = []
      this.noMore = false
      this.load()
    },
    load () {
      this.loading = true
      // planStatus 计划状态0启动1禁用
      this.$axios.get(this.$apis.patrol.selectPlanByPage, {
        page: this.page,
        size: this.size,
        projectId: this.projectId,
        planStatus: '0',
        ...this.searchInfo
      }).then((res) => {
        this.page++
        this.list = res && res.list.length > 0 ? this.list.concat(res.list) : this.list
        this.noMore = this.list.length >= res.total
      }).finally(() => {
        this.loading = false
      }).catch(() => {
        this.noMore = true
      })
    },
    onSelect (index) {
      if (this.currentIndex !== index) {
        this.currentIndex = index
        this.isShowRecord = true
      } else if (!this.isShowRecord) {
        this.isShowRecord = true
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  .el-form {
    display: flex;
    justify-content: space-between;
    .el-form-item {
      margin-right: 0;
    }
  }
  .list {
    width: 100%;
    max-height: 500px;
    overflow:auto;
    .infinite-list-item {
      cursor: pointer;
      .item-header {
        padding-right: 0;
        .name {
          flex-grow: 2;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: keep-all;
          overflow: hidden;
          margin-right: 10px;
        }
        .label {
          flex-shrink: 0;
          display: flex;
          justify-content: right;
          align-items: center;
          span {
            display: inline-block;
            height: 16px;
            font-size: 12px;
            color: #FFFFFF;
            line-height: 16px;
            background: #3592FE;
            border-radius: 2px;
            padding: 0 4px;
            margin-left: 2px;
            i {
              font-size: 10px;
              margin: 0 2px;
            }
          }
        }
      }
      .item-ctt {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding-bottom: 1px;
        p {
          min-width: 50%;
          margin-bottom: 9px;
        }
      }

      &.active {
        border-color: #1AD1B0;
        .item-header {
          background: #DCFAF5;
        }
      }
    }
    .tip {
      width: 100%;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 12px;
      text-align: center;
      padding: 10px 5px;
    }
  }
</style>
